export class Login
{
  username: string;
  password: string;
}



// WEBPACK FOOTER //
// /tmp/build_713add00/src/models/loginmodel.ts